export const STORAGE_PREFIX = '@promo.'

export enum STORAGE_KEY {
  AUTHENTICATED = 'authenticated',
  ACCESS_TOKEN = 'token',
  REFRESH_TOKEN = 'refreshToken',
  USER_INFO = 'user.info',
  DEVICE_UUID = 'deviceUuid',

  /** сохранение координат для заявки */
  COORDINATES = 'coordinates',
  /** для проверки доступа к админке */
  USER_TOKEN = 'user_token',
  /** сохранение типа ПВЗ для заявки */
  PICK_POINT_TYPE = 'typePoint',
  /** сохранение типа субсидии для заявки */
  SUBSIDY_HEX_TYPE = 'subsidyHexType',
  BANNER_HIDDEN = 'bannerHidden',
}

const memoryStorage = new Map<string, string>()

export const setLocalStorageData = (key: STORAGE_KEY, value: any) => {
  try {
    const jsonValue = JSON.stringify(value)
    const fullKey = getFullKey(key)
    memoryStorage.set(fullKey, jsonValue)
    localStorage.setItem(fullKey, jsonValue)
  } catch (e) {
    // saving error
  }
}

export const clearLocalStorageData = (key: STORAGE_KEY) => {
  try {
    const fullKey = getFullKey(key)
    memoryStorage.delete(fullKey)
    localStorage.removeItem(fullKey)
  } catch (e) {
    // saving error
  }
}

export const getLocalStorageData = (key: STORAGE_KEY) => {
  const fullKey = getFullKey(key)
  let value: string | undefined | null = memoryStorage.get(fullKey)

  if (!value) {
    value = localStorage.getItem(fullKey)
  }

  if (value) {
    try {
      return JSON.parse(value)
    } catch (error) {
      return value
    }
  }
}

export const memoryStorageClear = () => {
  memoryStorage.clear()
}

const getFullKey = (key: string) => STORAGE_PREFIX + key
